export default __webpack_public_path__ + "static/media/lock-icon.9def8cdf.svg";